import { Component, Input } from '@angular/core';
import { PurchasedProductInterface } from 'outshared-lib';
import { WucDisplayFieldModule } from '@inshared/website-ui-components';
import { DateFormatPipeModule } from '@inshared/shared/util-pipes';

@Component({
    standalone: true,
    selector: 'ins-insurance-start-date-data',
    templateUrl: './insurance-start-date-data.component.html',
    imports: [
        WucDisplayFieldModule,
        DateFormatPipeModule
    ]
})
export class InsuranceStartDateDataComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;
}
